import onboardingRoute from './onboarding';
import pendingDeposit from './pending-deposit';

export default [
  onboardingRoute,
  pendingDeposit,
];
